import buttonDataDefaults from './../ricos-schema/legacy/statics/button.defaults.json';
import type { AddButton } from './../ricos-types';
import { Node_Type } from './../ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from './../editor-common';

import { BUTTONS_TYPE_TO_TIPTAP_ATTR } from './constants';
import { INSERT_BUTTON_BUTTON } from './data-hooks';
import { InsertPluginIcon } from './icons';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons = (
  config: $TSFixMe,
  _services: $TSFixMe,
  type: $TSFixMe
): AddButton[] => {
  return [
    {
      id: Node_Type.BUTTON,
      label: INSERT_PLUGIN_BUTTONS.BUTTON,
      dataHook: INSERT_BUTTON_BUTTON,
      icon: InsertPluginIcon,
      tooltip: config?.insertButtonTooltip || 'ButtonPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        publicCommands.insertBlockWithBlankLines(type, {
          ...buttonDataDefaults,
          type: BUTTONS_TYPE_TO_TIPTAP_ATTR[
            type as $TSFixMeKey<typeof BUTTONS_TYPE_TO_TIPTAP_ATTR>
          ],
        });
        return true;
      },
      menuConfig: {
        tags: 'Button_plugin_search_tags',
        group: 'advanced',
      },
    },
  ];
};
